import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #F9F9F9;
  padding: 30px 15px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media(max-width: 1200px) {
      flex-wrap: wrap;
    }
    li {
      width: calc(25% - 25px);
      @media(max-width: 1200px) {
        width: calc(50% - 25px);
      }
      @media(max-width: 536px) {
        width: 100%;
        margin: 10px 0;
      }
      div {
        display: flex;
        align-items: center;
        flex-direction: column;
        h4 {
          font-size: 18px;
          text-transform: uppercase;
        }
        img {
          margin-bottom: 10px;
        }
      }
      p {
        font-size: 16px;
        font-weight: 400px;
        margin-top: 20px;
        text-align: center;
        line-height: 24px;
      }
    }
  }
`;
